export default __webpack_public_path__ + "static/media/Emojis12.dad0f664.png";